"use client";

import { c as _c } from "react-compiler-runtime";
import { AnimatePresence, motion } from "motion/react";
type CameraSwitchFadeProps = {
  isSwitching: boolean;
};
export function CameraSwitchFade(t0) {
  const $ = _c(4);
  const {
    isSwitching
  } = t0;
  let t1;
  if ($[0] !== isSwitching) {
    t1 = isSwitching && <motion.div animate={{
      opacity: 1
    }} className="absolute inset-0 z-30 bg-black" exit={{
      opacity: 0,
      transition: {
        duration: 0.3
      }
    }} initial={{
      opacity: 0
    }} transition={{
      duration: 0.1
    }} />;
    $[0] = isSwitching;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <AnimatePresence>{t1}</AnimatePresence>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}